import React, { useEffect, useState } from 'react';

import { LOCALSTORAGE_KEEP_ME_LOGGED_IN } from '../../../util/constants';
import { Checkbox } from '../../../v2/components/ui/checkbox';

const KeepMeLoggedIn = () => {
  const [isChecked, setIsChecked] = useState(true);

  useEffect(() => {
    localStorage.setItem(LOCALSTORAGE_KEEP_ME_LOGGED_IN, true);
  }, []);

  const onClick = () => {
    setIsChecked(!isChecked);
    localStorage.setItem(LOCALSTORAGE_KEEP_ME_LOGGED_IN, !isChecked);
  };

  return (
    <div className="mb-5 pl-5">
      <Checkbox checked={isChecked} onCheckedChange={onClick} />
    </div>
  );
};

// KeepMeLoggedIn.propTypes = {

// };

export default KeepMeLoggedIn;
